import { ChevronUp } from '@transferwise/icons';
import { clsx } from 'clsx';
import '../common/theme.mjs';
import '../common/direction.mjs';
import '../common/propsValues/control.mjs';
import '../common/propsValues/breakpoint.mjs';
import { Size } from '../common/propsValues/size.mjs';
import '../common/propsValues/typography.mjs';
import '../common/propsValues/width.mjs';
import '../common/propsValues/type.mjs';
import '../common/propsValues/dateMode.mjs';
import '../common/propsValues/monthFormat.mjs';
import { Position } from '../common/propsValues/position.mjs';
import '../common/propsValues/layouts.mjs';
import '../common/propsValues/status.mjs';
import '../common/propsValues/sentiment.mjs';
import '../common/propsValues/profileType.mjs';
import '../common/propsValues/variant.mjs';
import '../common/propsValues/scroll.mjs';
import '../common/propsValues/markdownNodeType.mjs';
import '../common/fileType.mjs';
import 'react';
import 'react-intl';
import '../common/closeButton/CloseButton.messages.mjs';
import { jsx } from 'react/jsx-runtime';

const CONTAINER_SIZE = {
  [Size.EXTRA_SMALL]: 10,
  [Size.SMALL]: 16,
  [Size.MEDIUM]: 24
};
const ExtraSmallChevron = ({
  className
}) => {
  return /*#__PURE__*/jsx("span", {
    className: clsx('tw-icon', 'tw-icon-chevron', className),
    role: "presentation",
    "aria-hidden": true,
    children: /*#__PURE__*/jsx("svg", {
      width: "10",
      height: "10",
      viewBox: "0 0 10 10",
      fill: "currentColor",
      focusable: "false",
      children: /*#__PURE__*/jsx("path", {
        fillRule: "evenodd",
        d: "M4.9995 2.0865L0.0635004 6.7645L1.2745 7.9125L4.9995 4.3835L8.7245 7.9135L9.9355 6.7645L4.9995 2.0865Z"
      })
    })
  });
};
const Chevron = ({
  orientation = Position.BOTTOM,
  size = Size.SMALL,
  disabled = false,
  className
}) => {
  const classNameValue = clsx('tw-chevron', {
    'chevron-color': !disabled
  }, orientation, className);
  if (size === Size.EXTRA_SMALL) {
    return /*#__PURE__*/jsx(ExtraSmallChevron, {
      className: classNameValue
    });
  }
  const sizeValue = CONTAINER_SIZE[size];
  return /*#__PURE__*/jsx(ChevronUp, {
    className: classNameValue,
    size: sizeValue
  });
};

export { Chevron as default };
//# sourceMappingURL=Chevron.mjs.map
